/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { saveAs } from 'file-saver';
import MolGrid, { Column } from "@moltech/molui/molgrid";
import { useNavigate } from "react-router-dom";

/** Utilities */
import { customRowsPerPageDropdown } from "../../../components/finalForms/libs/data/dropdownUtilities";

/** Common Components */
import CardSection from "../../../components/ui/card/CardSection";
import Checkbox from "../../../components/finalForms/ui/inputs/checkBox/CheckBox";
import Buttons from "../../../components/ui/button/Buttons";
import CustomCenterModel from "../../../components/ui/customCenterModel/CustomCenterModel";
import formatDate from "../../../components/finalMolGrid/libs/formatDate";

/** Common Services & Data Files */
import { AppIcons } from "../../../data/appIcons";

/** RTK Query */
import { useGetMolGridDataMutation } from "../../../app/services/commonAPI";
import { useExportContractsListMutation } from "../../../app/services/contractAPI";
import Contracts from "../Contracts";

/** Lazily Loaded Components */
const AddContracts = React.lazy(() => import("./addcontract/AddContracts"));
const ContractTypes = React.lazy(() => import("./contractTypes/ContractTypes"));

const Contractlist = () => {

  const gridRef = useRef();
  const navigate = useNavigate();

  const [isExpiredContract, setIsExpiredContract] = useState(false);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const currentDate = formatDate(new Date(), "MM-DD-YYYY");
  const [isModelOpenContractType, setIsModelOpenContractType] = useState(false);
  const [isDisable, setIsDisable] = useState(true);
  const [selectedRow, setSelectedRow] = useState({});

  const [exportContractsList, {
    isLoading: isExporting,
    isSuccess: isAllExported,
    data: exportAllData
  }] = useExportContractsListMutation();

  useEffect(() => {
    if (gridRef.current) {
      gridRef.current.reload();
    }
  }, [isExpiredContract])

  // Export All Details response handling
  useEffect(() => {
    if (!isExporting && isAllExported && exportAllData) {
      const blob = new Blob([exportAllData]);
      saveAs(blob, `Contracts ${currentDate}.xlsx`);
    }
  }, [isExporting, isAllExported, exportAllData]);


  const handalCheckboxChange = (e) => {
    setIsExpiredContract(!isExpiredContract);
  };

  const handleCloseModel = () => {
    setIsModelOpen(!isModelOpen);
  };

  const handalSuccessModel = () => {
    handleCloseModel();
    if (gridRef.current) {
      gridRef.current.reload();
    }
  }

  const handleCloseModel2 = () => {
    setIsModelOpenContractType(!isModelOpenContractType);
  };

  const handalExportContracts = () => {
    exportContractsList(isExpiredContract);
  }


  const beforeMolGridLoad = (reqPrm) => {
    const req = {
      pagination: {
        pageNumber: (reqPrm.first / reqPrm.rows) + 1,
        pageSize: reqPrm.rows
      },
      sortField: reqPrm.sortField,
      sortOrder: reqPrm.sortOrder,
      groupBy: reqPrm.groupBy ? reqPrm.groupBy : '',
      pbIncludeInactive: isExpiredContract,
      pbIncludeAll: false,
      pbIncludeEfficiency: false,
      pbAppendDatesToName: false,
      plContractKey: 0,
      psContractName: null,
      plClientKey: 0,
      psEfficiencyRating: null,
    };
    return req;
  }

  const handleRowDoubleClick = (event) => {
    navigate(`/EditContracts?contract=${event?.data?.contractKey}`);
  };

  const afterMolGridLoad = (data) => {
    setIsDisable(false);
    return {
      data: data.dataSource,
      count: data.totalRecord
    };
  }

  const getCtxMenuItems = (row) => {
    if (!row) return [];

    return [
      {
        label: "Edit Contract",
        command: () => navigate(`/EditContracts?contract=${row.contractKey}`),
      },
    ];
  };

  const headerContent = () => {
    return (
      <div className="d-flex gap-2">
        <span className="mr-3 d-flex">
          <Checkbox
            label="Show Expired Contracts"
            name="isContract"
            checked={isExpiredContract}
            onChange={handalCheckboxChange}
          />
        </span>
        <Buttons
          buttonText={"Add Contract"}
          buttonTypeClassName="btn blue-btn"
          onClick={() => setIsModelOpen(true)}
          titleText="Add Contract"
        />
        <Buttons
          buttonText={"Extract"}
          buttonTypeClassName="btn blue-btn"
          isDisable={isDisable}
          isLoading={isExporting}
          onClick={handalExportContracts}
          titleText="Extract Contracts"
        />
        <Buttons
          buttonText={"Contract Types"}
          buttonTypeClassName="btn blue-btn"
          onClick={() => setIsModelOpenContractType(true)}
          titleText="Contract Types"
        />
      </div>
    );
  };

  return (
    <div className="scopes-section contract-open-grid">
      <div className="row">
        <div className="table-pb-0 contarct-table ">
          <CardSection
            cardTitle="Contracts"
            customHeader={true}
            headerContent={headerContent()}
          >
            <MolGrid
              ref={gridRef} url="/Contract/GetAllContractsList" client={useGetMolGridDataMutation}
              beforeLoad={beforeMolGridLoad}
              afterLoad={afterMolGridLoad}
              grouping
              expandableRowGroups={true}
              paginator
              rows={99999}
              rowsPerPageOptions={[10, 25, 50, 100]}
              paginatorTemplate={{
                layout: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                RowsPerPageDropdown: (options) => {
                  return customRowsPerPageDropdown(options, options?.value)
                }
              }}
              scrollable
              scrollHeight="flex"
              filterDisplay="row"
              selection={selectedRow}
              sortMode="single"
              showGridlines
              resizableColumns

              ctxMenuItems={getCtxMenuItems}
              onRowDoubleClick={handleRowDoubleClick}
            >
              <Column field="contractKey" header="key" bodyStyle={{ textAlign: "center" }} sortable />
              <Column field="contractType" header="Contract Type" bodyStyle={{ textAlign: "center" }} grouping sortable />
              <Column field="sContractNumber" header="Purchase Order #" bodyStyle={{ textAlign: "center" }} grouping sortable />
              <Column field="contractName" header="Contract" bodyStyle={{ textAlign: "left" }} grouping sortable />
              <Column field="clientName" header="Client" bodyStyle={{ textAlign: "left" }} grouping sortable />
              <Column field="salesRep" header="Sales Rep" bodyStyle={{ textAlign: "center" }} grouping sortable />
              <Column field="dtDateTermination" header="Term Date" colType="datetime" format="mm/dd/yyyy" bodyStyle={{ textAlign: "center" }} sortable />
              <Column field="sInstallmentType" header="Frequency" bodyStyle={{ textAlign: "center" }} grouping sortable />
            </MolGrid>
          </CardSection>
        </div>

        <CustomCenterModel
          isOpen={isModelOpen}
          useCustomBg={true}
          modalTitle={"Add Contract"}
          contentClass="content-50"
          onClose={handleCloseModel}
          modalTitleIcon={AppIcons.AddIcon}
        >
          <AddContracts onClose={handleCloseModel} onSuccess={handalSuccessModel} />
        </CustomCenterModel>
        <CustomCenterModel
          isOpen={isModelOpenContractType}
          useCustomBg={true}
          modalTitle={"Contract Types"}
          contentClass="content-30"
          onClose={handleCloseModel2}
          modalTitleIcon={AppIcons.AddIcon}
        >
          <ContractTypes />
        </CustomCenterModel>
      </div>
    </div>
  );
};

export default Contracts(Contractlist);